export default {
  log: {
    farm_activity: {
      label: 'Activity',
      label_plural: 'Activities',
      fields: {
        area: {
          label: 'Areas',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        asset: {
          label: 'Assets',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        files: {
          label: 'Files',
          type: 'file',
          required: 0,
          data_schema: [{ id: null }],
        },
        geofield: {
          label: 'Geometry',
          type: 'geofield',
          required: 0,
          data_schema: [{ geom: '' }],
        },
        images: {
          label: 'Photos',
          type: 'image',
          required: 0,
          data_schema: [{ id: null }],
        },
        notes: {
          label: 'Notes',
          type: 'text_long',
          required: 0,
          data_schema: { value: '', format: 'farm_format' },
        },
        movement: {
          label: 'Movement',
          type: 'field_collection',
          required: 0,
          data_schema: { area: [{ id: null }], geometry: '' },
        },
        log_category: {
          label: 'Log category',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        log_owner: {
          label: 'Assigned to',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        inventory: {
          label: 'Inventory adjustments',
          type: 'field_collection',
          required: 0,
          data_schema: [{ asset: { id: null }, value: null }],
        },
        membership: {
          label: 'Group membership',
          type: 'field_collection',
          required: 0,
          data_schema: { group: [{ id: null }] },
        },
        quantity: {
          label: 'Quantity',
          type: 'field_collection',
          required: 0,
          data_schema: [{
            measure: '', value: null, unit: { id: null }, label: '',
          }],
        },
        flags: {
          label: 'Flags',
          type: 'list_text',
          required: 0,
          data_schema: [''],
        },
        data: {
          label: 'Data',
          type: 'text_long',
          required: 0,
          data_schema: '',
        },
        equipment: {
          label: 'Equipment used',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
      },
    },
    farm_harvest: {
      label: 'Harvest',
      label_plural: 'Harvests',
      fields: {
        files: {
          label: 'Files',
          type: 'file',
          required: 0,
          data_schema: [{ id: null }],
        },
        geofield: {
          label: 'Geometry',
          type: 'geofield',
          required: 0,
          data_schema: [{ geom: '' }],
        },
        images: {
          label: 'Photos',
          type: 'image',
          required: 0,
          data_schema: [{ id: null }],
        },
        notes: {
          label: 'Notes',
          type: 'text_long',
          required: 0,
          data_schema: { value: '', format: 'farm_format' },
        },
        quantity: {
          label: 'Quantity',
          type: 'field_collection',
          required: 0,
          data_schema: [{
            measure: '', value: null, unit: { id: null }, label: '',
          }],
        },
        asset: {
          label: 'Assets',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        movement: {
          label: 'Movement',
          type: 'field_collection',
          required: 0,
          data_schema: { area: [{ id: null }], geometry: '' },
        },
        area: {
          label: 'Areas',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        log_category: {
          label: 'Log category',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        log_owner: {
          label: 'Assigned to',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        lot_number: {
          label: 'Harvest lot number',
          type: 'text',
          required: 0,
          data_schema: '',
        },
        inventory: {
          label: 'Inventory adjustments',
          type: 'field_collection',
          required: 0,
          data_schema: [{ asset: { id: null }, value: null }],
        },
        flags: {
          label: 'Flags',
          type: 'list_text',
          required: 0,
          data_schema: [''],
        },
        data: {
          label: 'Data',
          type: 'text_long',
          required: 0,
          data_schema: '',
        },
        equipment: {
          label: 'Equipment used',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
      },
    },
    farm_input: {
      label: 'Input',
      label_plural: 'Inputs',
      fields: {
        area: {
          label: 'Areas',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        files: {
          label: 'Files',
          type: 'file',
          required: 0,
          data_schema: [{ id: null }],
        },
        geofield: {
          label: 'Geometry',
          type: 'geofield',
          required: 0,
          data_schema: [{ geom: '' }],
        },
        images: {
          label: 'Photos',
          type: 'image',
          required: 0,
          data_schema: [{ id: null }],
        },
        input_method: {
          label: 'Application method',
          type: 'text',
          required: 0,
          data_schema: '',
        },
        input_purpose: {
          label: 'Purpose',
          type: 'text',
          required: 0,
          data_schema: '',
        },
        input_source: {
          label: 'Source/manufacturer',
          type: 'text',
          required: 0,
          data_schema: '',
        },
        material: {
          label: 'Materials',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        notes: {
          label: 'Notes',
          type: 'text_long',
          required: 0,
          data_schema: { value: '', format: 'farm_format' },
        },
        quantity: {
          label: 'Quantity',
          type: 'field_collection',
          required: 0,
          data_schema: [{
            measure: '', value: null, unit: { id: null }, label: '',
          }],
        },
        asset: {
          label: 'Assets',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        movement: {
          label: 'Movement',
          type: 'field_collection',
          required: 0,
          data_schema: { area: [{ id: null }], geometry: '' },
        },
        log_category: {
          label: 'Log category',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        log_owner: {
          label: 'Assigned to',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        lot_number: {
          label: 'Input lot number',
          type: 'text',
          required: 0,
          data_schema: '',
        },
        date_purchase: {
          label: 'Date purchased',
          type: 'datestamp',
          required: 0,
          data_schema: null,
        },
        inventory: {
          label: 'Inventory adjustments',
          type: 'field_collection',
          required: 0,
          data_schema: [{ asset: { id: null }, value: null }],
        },
        flags: {
          label: 'Flags',
          type: 'list_text',
          required: 0,
          data_schema: [''],
        },
        data: {
          label: 'Data',
          type: 'text_long',
          required: 0,
          data_schema: '',
        },
        equipment: {
          label: 'Equipment used',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
      },
    },
    farm_observation: {
      label: 'Observation',
      label_plural: 'Observations',
      fields: {
        area: {
          label: 'Areas',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        asset: {
          label: 'Assets',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        files: {
          label: 'Files',
          type: 'file',
          required: 0,
          data_schema: [{ id: null }],
        },
        geofield: {
          label: 'Geometry',
          type: 'geofield',
          required: 0,
          data_schema: [{ geom: '' }],
        },
        images: {
          label: 'Photos',
          type: 'image',
          required: 0,
          data_schema: [{ id: null }],
        },
        notes: {
          label: 'Notes',
          type: 'text_long',
          required: 0,
          data_schema: { value: '', format: 'farm_format' },
        },
        quantity: {
          label: 'Quantity',
          type: 'field_collection',
          required: 0,
          data_schema: [{
            measure: '', value: null, unit: { id: null }, label: '',
          }],
        },
        movement: {
          label: 'Movement',
          type: 'field_collection',
          required: 0,
          data_schema: { area: [{ id: null }], geometry: '' },
        },
        log_category: {
          label: 'Log category',
          type: 'taxonomy_term_reference',
          required: 0,
          data_schema: [{ id: null }],
        },
        log_owner: {
          label: 'Assigned to',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
        membership: {
          label: 'Group membership',
          type: 'field_collection',
          required: 0,
          data_schema: { group: [{ id: null }] },
        },
        inventory: {
          label: 'Inventory adjustments',
          type: 'field_collection',
          required: 0,
          data_schema: [{ asset: { id: null }, value: null }],
        },
        flags: {
          label: 'Flags',
          type: 'list_text',
          required: 0,
          data_schema: [''],
        },
        data: {
          label: 'Data',
          type: 'text_long',
          required: 0,
          data_schema: '',
        },
        equipment: {
          label: 'Equipment used',
          type: 'entityreference',
          required: 0,
          data_schema: [{ id: null }],
        },
      },
    },
  },
};
